import React from 'react';
import AsyncPage from './async';
import DefaultConsumerLayout from '../../../../components/layout/DefaultConsumerLayout';

export default [
  <DefaultConsumerLayout
    key="/consumer/features/teeth-whitening"
    exact
    path="/consumer/features/teeth-whitening"
    component={AsyncPage}
  />,
];
